import './Report.scss';
import Header from "@components/Header/Header";
import EsfirusResume from "@components/ui/Resume/EsfirusResume";
import ReportHeader from "./BBs/header/header";
import EsfirusReportTable from "./BBs/table/Table";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { isEmpleado } from "@services/hooks/UserHook";
import EsfirusButtonNative from '@components/ui/Button/EsfirusButtonNative';
import backIcon from "@assets/images/icons/back-arrow.svg";
import useReportsGet from '@services/hooks/useReportsGet';
import { constants } from '@helpers/constants';
import { configurationService } from '@services/configApp';
import { emptyResourceRedirect } from '@helpers/navigate';
import moment from 'moment';
import { applyFiltersInDays } from './helpers';
moment.locale('es');

function Report() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const getReports = useReportsGet();

    const closedDays = useSelector((state) => (state as any).partes)?.closedDays ?? [];
    const obras = useSelector((state) => (state as any).obras).list;
    const reports = useSelector((state) => (state as any).reports);
    const { list: reportList, selectedTypeHour, search, selectedEmpresa, selectedMesAnio } = reports;

    const { resumenHorasExtra } = configurationService.getConfigReport();

    const [grid, setGrid] = useState({ columns: [], rows: [], selectedDate: selectedMesAnio });

    useEffect(() => {
        emptyResourceRedirect({ check: obras.length === 0, path: "/partes/resumen", navigate });
        refreshDataGrid();
    }, []);

    useEffect(() => {
        generateGrid()
    }, [reportList, selectedTypeHour, search, selectedEmpresa, selectedMesAnio, closedDays]);

    const refreshDataGrid = () => {
        dispatch(getReports() as any);
    }

    const getColumnsDays = () => {
        const mesAnio = moment(selectedMesAnio, "M-YYYY");
        const daysInMonth = mesAnio.daysInMonth();

        const daysArray = Array.from({ length: daysInMonth }, (_, i) =>
            String(i + 1).padStart(2, '0')
        );

        return daysArray.map((day: any, index: number) => ({ name: `${day}`, keymap: `${index + 1}` }));
    };

    const getRow = (report: any, columns: []) => {
        const row: any = {
            empleado: report.nombre_empleado
        };

        if (selectedMesAnio === '') {
            return {
                ...row,
                closedDays: [],
                id_empleado: report.id_empleado
            }
        }

        const mesAnioSplit = moment(selectedMesAnio, "M-YYYY");
        const month = mesAnioSplit.format("MM")
        const year = mesAnioSplit.format("YYYY")

        let totalHours = 0
        columns.forEach((date: any, index) => {
            const res = report.days.filter((r: any) => {
                const [formatDay, formatMonth, formatYear] = moment(r.inicio).format('DD/MM/YYYY').split('/');

                const isCurrentDay = formatYear == year &&
                    formatMonth == month &&
                    formatDay == date.name;
                return isCurrentDay
            });

            //sumamos si llegan varias horas el mismo dia
            const sumHours = res.map((r: any) => r.horas).reduce(
                (accumulator: any, currentValue: any) => {
                    return accumulator + currentValue
                }, 0
            );
            const horasExtra = Math.max(0, sumHours - 8);

            let allConfirmed = res.filter((r: any) => r.estado === constants.estadoParte.validado).length === res.length

            totalHours = totalHours + sumHours

            row[`${index}`] = {
                horas: sumHours,
                horasExtra,
                allConfirmed
            }
        });

        const closedDaysFiltered = closedDays?.filter((closed: any) => closed?.empleado === report.id_empleado)?.filter((closed: any) => {
            const [formatDay, formatMonth, formatYear] = moment(closed?.day).format('DD/MM/YYYY').split('/');
            if (!formatDay || !formatMonth || !formatYear) return false;
            const isCurrentDay = formatYear == year && formatMonth == month;
            return isCurrentDay;
        })?.map(
            (closed: any) => {
                const [formatDay] = moment(closed?.day).format('DD/MM/YYYY').split('/');
                return Number(formatDay)
            }
        )
            .filter((value: any, index: any, array: any) => {
                return array.indexOf(value) === index
            });

        return {
            ...row,
            closedDays: closedDaysFiltered,
            id_empleado: report.id_empleado,
            total: totalHours
        }
    }

    const generateGrid = () => {
        if (selectedMesAnio === '') {
            setGrid({ columns: [], rows: [], selectedDate: selectedMesAnio });
            return
        };

        const _grid: any = {
            columns: [
                {
                    name: 'Empleado',
                    keymap: 'empleado'
                },
            ],
            rows: [],
            selectedDate: selectedMesAnio
        };

        _grid.columns = _grid.columns.concat(getColumnsDays())

        if (isEmpleado()) {
            const userId = Number(localStorage.getItem("ef-user-id"));
            const userFiltered = reportList?.filter((r: any) => r.id_empleado === userId) ?? [];
            const withDaysFiltered = userFiltered?.map((p: any) => ({
                ...p,
                days: applyFiltersInDays(p.days, selectedTypeHour, selectedEmpresa, selectedMesAnio),
            }));

            _grid.rows = withDaysFiltered?.map((r: any) => getRow(r, _grid.columns))
        } else {
            const searchFiltered = reportList?.filter((p: any) => (p.nombre_empleado || "").toString().toLowerCase().includes(search.toLowerCase())) ?? [];
            const withDaysFiltered = searchFiltered?.map((p: any) => ({
                ...p,
                days: applyFiltersInDays(p.days, selectedTypeHour, selectedEmpresa, selectedMesAnio),
            }));

            _grid.rows = withDaysFiltered?.map((r: any) => getRow(r, _grid.columns)).filter((r: any) => r.total > 0);
        }

        setGrid(_grid);
    }

    return (
        <>
            <Header />
            <div className="center ef-report">
                <div className="ef-report-title">
                    <EsfirusButtonNative
                        className={"tertiary"}
                        label={window.innerWidth > 500 ? "Volver" : ""}
                        icon={backIcon}
                        iconClass={"icon-tertiary"}
                        click={() => {
                            navigate("/partes")
                        }}
                    ></EsfirusButtonNative>
                    <div className="title">
                        <h4>Resumen mensual</h4>
                        <p>Selecciona la empresa y el mes que quieras visualizar</p>
                    </div>
                </div>
                {reportList?.length === 0 ? (
                    <div className='no-month-selected' style={{ color: "#075577" }}>Listado de reportes por empleado vació. Cargando datos...</div>
                ) : (
                    <>
                        <ReportHeader selectedTypeHour={selectedTypeHour} selectedEmpresa={selectedEmpresa} selectedMesAnio={selectedMesAnio} admin={!isEmpleado()}></ReportHeader>
                        {window.innerWidth > 500 ?
                            <>
                                {!Boolean(selectedMesAnio) ? (
                                    <div className='no-month-selected'>Debes seleccionar un mes en el desplegable para poder mostrar el reporte.</div>
                                ) : (
                                    <EsfirusReportTable grid={grid} />
                                )}

                                <EsfirusResume partes={[]} reports={grid} resumenMensual={true} resumenHorasExtra={resumenHorasExtra} ></EsfirusResume>
                            </>
                            :
                            <div className="title-rotate">

                                <p>Rota la pantalla para poder ver</p>
                            </div>
                        }
                    </>
                )}
            </div>
        </>
    );
}

export default Report;